import { NgStyle } from '@angular/common';
import { Component } from '@angular/core';
import { AbstractTailoredTemplateWidget } from '../AbstractTailoredWidgetTemplate.class';

@Component({
    styleUrls: ['./template-widget-section-title.scss'],
    selector: 'template-widget-section-title',
    templateUrl: 'template-widget-section-title.html',
    imports: [NgStyle]
})
export class TemplateWidgetSectionTitleComponent extends AbstractTailoredTemplateWidget<{ value: string; backgroundColor: string }> {}
